export const initialProducts = [
  { 
    id: 1, 
    name: 'Wireless Headphones', 
    category: 'Electronics', 
    price: 79.99, 
    image: '', 
    stock: 45, 
    description: 'Premium sound quality with noise cancellation' 
  },
  { 
    id: 2, 
    name: 'Smart Watch', 
    category: 'Electronics', 
    price: 199.99, 
    image: '', 
    stock: 23, 
    description: 'Track your fitness and stay connected' 
  },
  { 
    id: 3, 
    name: 'Laptop Backpack', 
    category: 'Accessories', 
    price: 49.99, 
    image: '', 
    stock: 67, 
    description: 'Durable and spacious for all your gear' 
  },
  { 
    id: 4, 
    name: 'Coffee Maker', 
    category: 'Home', 
    price: 89.99, 
    image: '', 
    stock: 34, 
    description: 'Brew the perfect cup every morning' 
  },
  { 
    id: 5, 
    name: 'Yoga Mat', 
    category: 'Sports', 
    price: 29.99, 
    image: '', 
    stock: 89, 
    description: 'Non-slip surface for comfortable practice' 
  },
  { 
    id: 6, 
    name: 'Running Shoes', 
    category: 'Sports', 
    price: 119.99, 
    image: '', 
    stock: 12, 
    description: 'Lightweight and cushioned for maximum comfort' 
  },
];

export const categories = ['Electronics', 'Accessories', 'Home', 'Sports', 'Clothing', 'Books'];